import React, { useEffect, useMemo, useState } from "react";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";
import CardHeader from "@commons/businesscardHeader";
import Fields from "@components/fields";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import generalSettings from "@apis/generalSettings";
import { RootState } from "@store/index";
import { toast } from "react-toastify";

const SplashScreen = () => {
  const splashScreenState = useSelector(
    (state: RootState) => state.splashScreen,
  );

  const splashSettings = Array.isArray(splashScreenState?.data)
    ? splashScreenState.data
    : [];

  const [loading, setLoading] = useState(false);

  const fetchSettings = async () => {
    await generalSettings.getByGroup({
      state: "splashScreen",
      id: "splashscreen",
      showErr: false,
    });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const initialValues = useMemo(() => {
    const splash = splashSettings?.find(
      (item: any) => item.key === "splash-screen-media",
    );
    return {
      splashScreenMedia: splash ? `${splash.file}` : null,
    };
  }, [splashSettings]);

  const handleUpload = async (file: any) => {
    if (!file) return toast.error("Please select a file first.");

    setLoading(true);
    const formData = new FormData();
    // Support both raw file from upload field and existing string URL
    if (file.rawFile) {
      formData.append("file", file.rawFile);
    }
    formData.append("key", "splash-screen-media");
    formData.append("group", "splashscreen");
    formData.append("value", "SplashScreenMedia");

    try {
      const existing = splashSettings?.find(
        (i: any) => i.key === "splash-screen-media",
      );
      if (existing) {
        await generalSettings.update({
          state: "splashScreen",
          id: existing.id,
          data: formData,
        });
      } else {
        await generalSettings.create({
          state: "splashScreen",
          data: formData,
        });
      }
      toast.success("Splash screen media updated successfully!");
    } catch (err) {
      toast.error("Failed to upload splash screen media.");
      console.error(err);
    } finally {
      setLoading(false);
      fetchSettings();
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={() => {}}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="Splash Screen Loading" />
          <Wrapper>
            <div style={{ width: "281px", margin: "0 auto" }}>
              <Fields.Upload
                name="splashScreenMedia"
                label="Upload Image, GIF, or MP4 Video (9:16 Aspect Ratio)"
                height={500}
                useRawFile={true}
                onChange={(file: any) =>
                  setFieldValue("splashScreenMedia", file)
                }
              />
              <div style={{ marginTop: "2rem", textAlign: "center" }}>
                <Button
                  loading={loading}
                  disabled={
                    !values.splashScreenMedia ||
                    typeof values.splashScreenMedia === "string"
                  }
                  title={
                    values.splashScreenMedia ? "Update Media" : "Upload Media"
                  }
                  type="button"
                  onClick={() => handleUpload(values.splashScreenMedia)}
                />
              </div>
            </div>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default SplashScreen;
